module.exports = __webpack_public_path__ + "img/works_ssFire_btm_off_m.fe2c1a8b.jpg";